/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Rich_Frog_FawnInputs */

const en_soft_rich_frog_fawn = /** @type {(inputs: Soft_Rich_Frog_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Report`)
};

const de_soft_rich_frog_fawn = /** @type {(inputs: Soft_Rich_Frog_FawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht freigeben`)
};

/**
* | output |
* | --- |
* | "Share Report" |
*
* @param {Soft_Rich_Frog_FawnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_rich_frog_fawn = /** @type {((inputs?: Soft_Rich_Frog_FawnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Rich_Frog_FawnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_rich_frog_fawn(inputs)
	return de_soft_rich_frog_fawn(inputs)
});